import { AppConfig } from "config/schema";

const config: AppConfig = {
  basePath: "",
  contact: {
    email: "enquiries@sook.space",
    jenni: "jenni@sook.space",
    phone: "+44 (0) 203 4889333",
    newsletter:
      "https://manage.kmail-lists.com/subscriptions/subscribe?a=USxEAV&g=Xpd77M&utm_source=Klaviyo&utm_medium=email&utm_campaign=from-depop-to-popup%20%28TNDBTG%29&_kx=SiERLpr4uShXFs27J2-8nD7msyCCCbghqsuQUi8HmAo%3D.USxEAV",
    scheduleCallURL:
      "https://meetings.hubspot.com/dmitrij-borscs/sook-meeting-booking-form",
  },
  spaces: {
    previewURL: "",
  },
  hubspot: {
    appID: "",
  },
  social: {
    facebookURL: "https://facebook.com/sookspaces/",
    twitterURL: "https://twitter.com/SookSpaces",
    linkedInURL: "https://www.linkedin.com/company/sook/",
    instagramURL: "https://www.instagram.com/sookspaces/",
  },
  api: {
    url: "",
  },
  analytics: {
    minHour: 7,
    maxHour: 22,
  },
  designs: {
    reloadStatusDelay: 5000,
  },
  google: {
    signInClientID: "",
    requiredScopes: [
      "profile",
      "email",
      "https://www.googleapis.com/auth/drive.file",
    ],
    analyticsTrackerID: "",
    tagManagerAccountID: "",
    apiKey: "",
  },
  stripe: {
    apiKey: "",
  },
  sentry: {
    url: "",
  },
  canva: {
    apiKey: "",
  },
  youTube: {
    apiKey: "",
  },
  countries: {
    defaultCountry: "gb",
    flagsDir: "/assets/img/country-flags/",
    listURL: "/assets/data/countries.json",
  },
  crowdfunding: {
    url: "https://www.crowdcube.com/sook",
  },
  tenancyCalculator: {
    rates: [
      [90, 200, 225],
      [90, 200, 225],
      [90, 200, 225],
      [90, 200, 225],
      [90, 200, 300],
      [150, 400, 450],
      [150, 400, 450],
    ],
    maxShortTermDays: 14,
  },
};

export default config;
